import FragmentDataType from "../enums/fragment-data-type";
import { FragmentMessages } from "../../common/fragment-messages";
import FragmentSummary from "./fragment-summary";
import Fragment from "./fragment";

export default class FieldGoalOutOfBounds extends Fragment {
    constructor(fieldPosition) {
        super();
        this.code = "M";
        this.fieldPosition = fieldPosition;

        this.requiredData = [
            {
                name: "fieldPosition",
                type: FragmentDataType.FieldPosition,
                displayName: "Field Position",
                title: "Field Position",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                showEndZoneYards: (gameConfig) =>
                    gameConfig.general.includeEndZoneYardage
            }
        ];
    }

    summarize(summaryContext, stringifier) {
        const message = `out-of-bounds at the 		
		${stringifier.niceFieldPosition(
            summaryContext.gameConfig.general.fieldLength,
            this.fieldPosition,
            summaryContext.homeTeam?.abbrName,
            summaryContext.awayTeam?.abbrName
        )}`;

        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.eopPrinted = true;
        summaryContext.fieldPosition = this.fieldPosition;
        summaryContext.homeTeamHasPossession =
            !summaryContext.homeTeamHasPossession;
    }
}
